/* eslint-disable */
import React, { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Handles all redirects in the application. This component is used for:
 * 1. Redirecting invalid URLs to appropriate pages
 * 2. Supporting URLs that omit the /invoice prefix
 */
const Redirects = (): JSX.Element => {
  const { invoiceId } = useParams<{ invoiceId?: string }>();
  const location = useLocation();
  const pathnameArray = location.pathname.split('/');

  // First checks in the URL if it has /invoice, if not, it will redirect to /invoice
  if (!/^\/invoice\/.*/.test(window.location.pathname)) {
    return <Navigate to={`/invoice${location.pathname}`} replace />;
  }
  if (pathnameArray[2].length) {
    return <Navigate to={`/invoice/${pathnameArray[2]}`} replace />;
  }

  useEffect(() => {
    // Log attempts to access invalid URLs
    // eslint-disable-next-line no-console
    console.info(`Redirecting from invalid URL: ${location.pathname}`);
  }, [location.pathname]);

  // If we have an invoice ID from the URL, extract the page type
  if (invoiceId) {
    // Check if this is a known path pattern that's missing the /invoice prefix
    const path = location.pathname;

    // Extract potential invoice ID from the path for URLs without /invoice prefix
    if (path.endsWith('/address')) {
      return <Navigate to={`/invoice/${invoiceId}/address`} replace />;
    }

    // Redirect to the payment page if the URL ends with /pay
    if (path.endsWith('/pay')) {
      return <Navigate to={`/invoice/${invoiceId}/pay`} replace />;
    }

    // Redirect to the confirmation page if the URL ends with /confirmation
    if (path.endsWith('/confirmation')) {
      return <Navigate to={`/invoice/${invoiceId}/confirmation`} replace />;
    }

    // Default to the summary page with the potential invoice ID
    return <Navigate to={`/invoice/${invoiceId}`} replace />;
  }

  // If all else fails, just redirect to root (which will show a "not found" message)
  return <Navigate to="/order-not-found" replace />;
};

export default Redirects;
